<div class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
    <h1 class="tw-text-2xl">{{ 'PAGE-NOT-FOUND' | translate }}</h1>
</div>
